export default __webpack_public_path__ + "static/media/logo-pro.0215b363.png";